import { IState } from 'shared/store';

import { abUseExperimentsSelector, isAbUseExperimentsActive } from '../abUseExperiments';

// TODO: Удалить в CD-197476
export const NEWBUILDING_PRICE_PLATE_EXPERIMENT = 'newbuilding_multiprice_on_kaob_desktop';

// TODO: Удалить в CD-197476
export const selectNewbuildingPricePlateExperimentActive = (state: IState) => {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentsActive(experiments, NEWBUILDING_PRICE_PLATE_EXPERIMENT, 'enabled');
};
